import { Injectable } from '@angular/core';

import { RdsDialogService } from '@rds/angular-components';
import { RdsDialogSize } from '@rds/core';

import { ConfirmComponent } from '../page/confirm/confirm.component';

type dialogType = 'confirm' | 'info' | 'warn' | 'warning';

@Injectable({
    providedIn: 'root',
})
export class DialogService {
    constructor(private readonly dialog: RdsDialogService) {}

    confirmationDialog(
        title: string,
        body: string,
        type: dialogType,
        size: RdsDialogSize,
        data?: string,
        panelClass?: string,
        confirmButtonText?: string
    ) {
        return this.dialog.open(ConfirmComponent, {
            data: { body, data, title, type, confirmButtonText },
            size,
            panelClass: panelClass || undefined,
        });
    }
}
